import { render, staticRenderFns } from "./ClientEditTabFeature.vue?vue&type=template&id=7ed192e5&"
import script from "./ClientEditTabFeature.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabFeature.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabFeature.vue?vue&type=style&index=0&id=7ed192e5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports